export default interface CashRegType {
    id: number;
    name: string;
}

export const cashRegTypeDefaultProps: CashRegType = {
    id: 0,
    name: '',
}